import { apiUrl } from "./api";

export type AnalyticsValue = string | number | boolean;

const SESSION_KEY = "nex_analytics_session";

function sessionId(): string {
  if (typeof window === "undefined") return "server";
  const existing = window.sessionStorage.getItem(SESSION_KEY);
  if (existing) return existing;
  const created = crypto.randomUUID();
  window.sessionStorage.setItem(SESSION_KEY, created);
  return created;
}

export function trackEvent(eventName: string, properties: Record<string, AnalyticsValue> = {}): void {
  if (typeof window === "undefined") return;
  const safeProperties = Object.fromEntries(Object.entries(properties).filter(([key, value]) => /^[a-z0-9_]{1,40}$/.test(key) && (typeof value === "string" || typeof value === "number" || typeof value === "boolean")));
  void fetch(apiUrl("/api/analytics/events"), { method: "POST", keepalive: true, headers: { "Content-Type": "application/json" }, body: JSON.stringify({ event_name: eventName, session_id: sessionId(), route: window.location.pathname, properties: safeProperties }) }).catch(() => undefined);
}
